
// usage: holdButton(d3.selectAll('.hold-btn'), (el, evt, d) => { /* delete */ }, 2000)
export function holdButton(selection, onHoldComplete, duration = 1000) {
    const state = new WeakMap();
  
    selection.each(function () {
      const el = this;
      const btn = d3.select(el);
      state.set(el, { timer: null, done: false });
  
      const start = (event) => {
        const s = state.get(el);
        if (!s || s.done) return;
        btn.classed('is-holding', true);
        // avoid text selection while holding
        event.preventDefault?.();
  
        s.timer = setTimeout(() => {
          s.done = true;
          btn.classed('is-holding', false).classed('is-done', true);
          onHoldComplete && onHoldComplete(el, event, btn.datum());
        }, duration);
      };
  
      const cancel = () => {
        const s = state.get(el);
        if (!s) return;
        clearTimeout(s.timer);
        if (!s.done) btn.classed('is-holding', false);
      };
  
      btn
        .on('pointerdown.hold', start)
        .on('pointerup.hold pointerleave.hold pointercancel.hold', cancel)
        .on('contextmenu.hold', (e) => e.preventDefault()); // stop long-press menu
    });
  
    // optional tiny API
    selection.resetHold = () =>
      selection.each(function () {
        const s = state.get(this);
        if (s) s.done = false;
        d3.select(this).classed('is-done', false).classed('is-holding', false);
      });
  
    return selection;
  }



export function createCard({ id, title, subtitle = "", note = "", faviconURL, image, badge = "", extras = "" } = {}) {
  if(!["ok", "waiting", "error"].includes(badge)) badge = "";
  const view = d3.create('div')
    .attr("role", "button")
    .attr("tabindex", "0")
    .id(id)
    .class("admin-card");
    
  view.append("img").class("icon").attr("src", image);
  const titleEl = view.append("div").class("card-top-row");
  if(faviconURL) titleEl.append("span").class("favicon-placeholder").html(`<img class="favicon" src="${faviconURL}">`);
  titleEl.append("span").class("badge " + badge).style("display",badge?null:"none").html(badge);
  titleEl.append("span").class("card-title").html(title);
  titleEl.append("span").class("card-subtitle").html(subtitle);
  view.append("div").class("card-note").html(note);
  view.append("div").class("card-extras").html(extras);
  
  return view.node();
}



// card selection controller
export function makeCardSelectable(container, onSelect) {
  const cards = d3.selectAll('.admin-card');

  const select = (el) => {
    d3.selectAll('.admin-card').classed("is-selected", false)
    if (el) {
      el.classList.add('is-selected');
      onSelect(el.id);
    }
  };

  const isCard = (el) => el?.classList?.contains('admin-card');

  container.on('click', null);
  container.on('click', (e) => {
    const target = e.target.closest('.admin-card');
    if (isCard(target)) select(target);
  });

  container.on('keydown', null);
  container.on('keydown', (e) => {
    const target = e.target.closest('.admin-card');
    if (!isCard(target)) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      select(target);
    }
    // optional: arrow key navigation
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      const next = target.nextElementSibling?.classList.contains('admin-card') ? target.nextElementSibling : null;
      next?.focus();
    }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = target.previousElementSibling?.classList.contains('admin-card') ? target.previousElementSibling : null;
      prev?.focus();
    }
  });

  // expose API
  return { selectById: (id) => select(cards.find(c => c.id === id)) };
}

export function sidebarCollapseController(pageWithSidebarSelector) {
  const root = d3.select(pageWithSidebarSelector);
  const toggleBtn = root.select('#sidebarToggle');

  const collapsedKey = 'admin.sidebar.collapsed'
  if (localStorage.getItem(collapsedKey) === '1') root.classed('is-collapsed', true);

  toggleBtn.on('click', () => {
    const collapsed = !root.classed('is-collapsed');
    root.classed('is-collapsed', collapsed)
    localStorage.setItem(collapsedKey, collapsed ? '1' : '0')
  })
}